import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOCKED_EVENT = "kipkruiden-locked";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && err.response?.data?.detail === "access required") {
      window.dispatchEvent(new Event(LOCKED_EVENT));
      // Vergrendelscherm neemt het over; laat de oorspronkelijke aanroep stil wachten.
      return new Promise(() => {});
    }
    return Promise.reject(err);
  },
);
